import { useContext } from "react";
import { Helmet } from "react-helmet-async";
import { LangContext } from "../../App";

/**
 * SEO component to place on every page of the website.
 * Handles title, description, canonical, Open Graph, Twitter Card, and hreflang tags.
 * Language-aware: switches meta content based on current language context.
 *
 * @param {object} data - SEO data object from seo.data.js
 */
const SEOBlock = ({ data }) => {
    const { language } = useContext(LangContext);
    const title = language === "EN" && data.titleEN ? data.titleEN : data.title;
    const description =
        language === "EN" && data.descriptionEN ? data.descriptionEN : data.description;
    const ogImage = data.ogImage || "https://myvoiceup.ch/website_og_image.png";

    return (
        <Helmet>
            <html lang={language === "EN" ? "en" : "fr"} />
            <title>{title}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={data.canonHREF} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={data.canonHREF} />
            <meta property="og:image" content={ogImage} />
            <meta property="og:type" content="website" />
            <meta property="og:locale" content={language === "EN" ? "en_CH" : "fr_CH"} />
            <meta property="og:site_name" content="Voice Up" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={ogImage} />
            <link rel="alternate" hreflang="fr" href={data.canonHREF} />
            <link rel="alternate" hreflang="en" href={data.canonHREF} />
            <link rel="alternate" hreflang="x-default" href={data.canonHREF} />
        </Helmet>
    );
};

export default SEOBlock;
